import { COLORS, FONTS, SPACINGS } from "@constants";
import { ReactNode } from "react";
import styled from "styled-components";

interface TypeTagProps {
  isSelected: boolean;
  onClick: () => void;
  children: ReactNode;
  type?: "button" | "submit" | "reset";
}

function TypeTag({ isSelected, onClick, children, type = "button" }: TypeTagProps) {
  return (
    <StyledButton isSelected={isSelected} onClick={onClick} type={type}>
      {children}
    </StyledButton>
  );
}

export default TypeTag;

const StyledButton = styled.button<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${SPACINGS.SIZE_2};
  padding: ${SPACINGS.SIZE_1_5} ${SPACINGS.SIZE_4};
  height: 32px;
  border-radius: 100px;
  border: ${({ isSelected }) =>
    isSelected ? `2px solid ${COLORS.HALO_BLUE}` : `1px solid ${COLORS.NEUTRAL_250}`};
  background-color: ${({ isSelected }) => (isSelected ? COLORS.BLUE_LIGHT_250 : COLORS.NEUTRAL_0)};
  ${FONTS.MEDIUM_3};
  color: ${COLORS.NEUTRAL_800};
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    opacity: 0.8;
  }
`;
